import {getField, updateField} from "vuex-map-fields";
import {getTimingState} from "@/store/States";

const state = getTimingState()

const getters = {
    getTimingField(state) {
        return getField(state.form);
    },
}

const actions = {}

const mutations = {
    resetState(state) {
        Object.assign(state, getTimingState())
    },
    setForm(state, form) {
        state.form.startDate = `${form.startYear}-${form.startMonth}-${form.startDay}`
        state.form.startTime = `${form.startHour}:${form.startMinute}`
        state.form.winnerDate = `${form.winnerYear}-${form.winnerMonth}-${form.winnerDay}`
        state.form.winnerTime = `${form.winnerHour}:${form.winnerMinute}`
    },
    updateTimingField(state, field) {
        updateField(state.form, field);
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
